import React from 'react';
import { motion } from 'framer-motion';
import vectorimg from "../assets/images/Vector1.png";
import profile from "../assets/images/profile.png";

export default function WhatOurClientSay() {
    return (
        <>
            <div className='px-[8%] py-[6%] grid lg:grid-cols-12 gap-8'>

                {/* Left Section with animations */}
                <motion.div 
                    className='lg:col-span-5 px-12'
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false}}
                    transition={{ type: "spring", stiffness: 100, damping: 25 }}
                >
                    <p className='flex color-[#002455] tracking-[0.3rem] uppercase text-[1rem]'>
                        Testimonials
                        <span className='text-[var(--second-primary-color)] text-2xl leading-[.5] pl-3'>&#8594;</span>
                    </p>
                    <h3 className='pt-6 text-[1.5rem] font-[800] leading-[1.3]'>
                        What our <br /><span className='relative text-[var(--second-primary-color)] client'>Clients</span> say
                    </h3>
                    <p className='text-[.9rem] text-[#555D68] py-12'>
                        Here's what some of our clients have to say about their experience using Fastest
                    </p>
                </motion.div>

                {/* Right Section with scroll animations for cards */}
                <motion.div 
                    className="lg:col-span-7 px-12 "
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: false}}
                    transition={{ duration: 1, type: "tween" }}
                >
                    <div className='grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-8'>
                        {[
                            {
                                text: "I've been a client of Fastest for several years now, and I couldn't be happier with the level of professionalism and expertise they provide.",
                                name: "Sarah L",
                                img: profile,
                            },
                            {
                                text: "I've been a client of Fastest for several years now, and I couldn't be happier with the level of professionalism and expertise they provide.",
                                name: "Sarah L",
                                img: profile,
                            },
                        ].map((item, index) => (
                            <motion.div
                                key={index}
                                className='shadow-lg rounded-sm pt-6 bg-[#FAFAFA]'
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.2, duration: 0.6 }}
                            >
                                <div className='px-8'>
                                    <motion.img
                                        src={vectorimg}
                                        alt="vector image"
                                        className='w-[20px]'
                                        initial={{ opacity: 0, x: -20 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.9 }}
                                    />
                                    <p className='text-[.9rem] text-[#555D68] py-10'>
                                        {item.text}
                                    </p>
                                </div>
                                <p className='flex text-[.7rem] text-[#555D68] bg-white p-2'>
                                    <span className='flex items-center justify-center w-[25px] h-[25px] rounded-full bg-gray-100 mx-4'>
                                        <motion.img
                                            src={item.img}
                                            alt="icon"
                                            className='w-[15px]'
                                            whileHover={{ scale: 1.1 }}
                                            transition={{ type: 'spring', stiffness: 200 }}
                                        />
                                    </span>
                                    <span className='leading-[1.7] text-[.8rem]'>{item.name}</span>
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </>
    );
}
